/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant
 */
export interface SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant
   */
  assistantId: string;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant interface.
 */
export function instanceOfSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant(
  value: object,
): value is SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantFromJSON(
  json: any,
): SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant {
  return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
  };
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistantToJSON(
  value?: Omit<SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerOpenAiAssistant, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
  };
}
